import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Van-to-van stock transfers, as logistics sees them.
//
// Read-only on purpose. Whether the office should be able to intervene is a
// separate decision, and one worth taking once there is evidence of what
// actually goes wrong — stale pendings, or declines — rather than guessing at a
// resolution flow now.

export function useVanTransfers(filters = {}) {
  const params = new URLSearchParams();
  if (filters.status) params.set('status', filters.status);
  if (filters.van) params.set('van', filters.van);
  const qs = params.toString();

  return useQuery({
    queryKey: ['van-transfers', filters.status || '', filters.van || ''],
    queryFn: async () => (await api.get(`/api/van-transfers/all${qs ? `?${qs}` : ''}`)).data,
    // A work queue: a stale one means two people look at the same thing.
    staleTime: 0,
    retry: false,
  });
}

export function useTransferLines(id) {
  return useQuery({
    queryKey: ['van-transfers', 'lines', id],
    queryFn: async () => (await api.get(`/api/van-transfers/all/${id}/lines`)).data.lines,
    enabled: Boolean(id),
    staleTime: 60_000,
  });
}
